<div class="dialog-container">
  <div class="dialog-header">
    <h2>Criar Nova Macro</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon matTooltip="Fechar diálogo">close</mat-icon>
    </button>
  </div>

  <div class="dialog-content mb-2">
    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

    <form [formGroup]="masterForm" (ngSubmit)="onConfirmar()">
      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Grupo da Rede</mat-label>
            <input matInput formControlName="descricaoGrupo" maxlength="100" required />
            <mat-icon (click)="openDialog()" matIconSuffix>search</mat-icon>
            <mat-icon (click)="limpaFiltro()" aria-hidden="false" aria-label="Limpe o resultado da pesquisa"
              matIconSuffix>delete</mat-icon>
            <mat-error *ngIf="masterForm.get('descricaoGrupo')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome da Macro</mat-label>
            <input matInput formControlName="nome" maxlength="100" required />
            <mat-error *ngIf="masterForm.get('nome')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row g-2">
        <div class="col-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email do Usuário</mat-label>
            <input matInput formControlName="dscemail" maxlength="100" required />
            <mat-error *ngIf="masterForm.get('dscemail')?.hasError('required')">Obrigatório</mat-error>
          </mat-form-field>
        </div>

      </div>
      <div class="row g-2">
        <div class="col d-flex justify-content-end gap-2">
          <button mat-flat-button color="accent" type="submit" [disabled]="loading || !masterForm.valid">
            <mat-icon>check</mat-icon> Confirmar
          </button>
          <button mat-flat-button type="button" (click)="onCancelar()" [disabled]="loading">
            <mat-icon>close</mat-icon> Cancelar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>